import axios from "axios";
import axiosInstance from "../utils/axiosInterceptor";

const baseUrls = {
  v1: `${process.env.REACT_APP_BASE_URL_VMS}/api/v1/`,
  v3: `${process.env.REACT_APP_BASE_URL_VMS}/api/v3/`,
};

// 🚫 apicall WITHOUT interceptor
export const apicallWithoutInterceptor = async (
  path,
  method = "get",
  data = null,
  options = {},
  version = "v1"
) => {
  const headers = {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    AccessToken: localStorage.getItem("accessToken"),
    ...options.headers,
  };

  return await axios({
    method,
    url: baseUrls[version] + path,
    data,
    headers,
    ...options,
  });
};

// ✅ apicall WITH interceptor
export const apicall = async (
  path,
  method = "get",
  data = null,
  options = {},
  version = "v1"
) => {
  const defaultHeaders = {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Allow-Origin": "*",
    accessToken: localStorage.getItem("accessToken"),
  };

  const config = {
    method,
    url: baseUrls[version] + path,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
    ...options, 
  };

  if (data != null) {
    config.data = data;
  }

  return await axiosInstance(config);
};
